<p-toast position="bottom-right"></p-toast>

<form [formGroup]="form" (ngSubmit)="model ? update() : create()" appPermissionControl="P268F0001">
    <div class="form-row">
        <div class="form-field">
            <input pInputText type="text" formControlName="sCampo" class="form-control" 
                [placeholder]="'Ingrese nombre del campo'" 
                [disabled]="model" appPermissionControl="P268K0001">
            <label>Campo</label>
        </div>
    </div>

    <div class="form-row">
        <div class="form-field">
            <p-dropdown 
                formControlName="sTipo" 
                [options]="tiposOptions" 
                optionLabel="label" 
                appendTo="body"
                optionValue="value"
                [filter]="true"
                placeholder="Seleccione un tipo"
                class="w-100" appPermissionControl="P268K0002">
            </p-dropdown>
            <label>Tipo</label>
        </div>
    </div>

    <div class="form-row">
        <div class="form-field">
            <p-dropdown 
                formControlName="sTabla" 
                [options]="tablasOptions" 
                optionLabel="label" 
                appendTo="body"
                optionValue="value"
                [filter]="true"
                [disabled]="model"
                placeholder="Seleccione una tabla"
                class="w-100" appPermissionControl="P268K0003">
            </p-dropdown>
            <label>Tabla</label>
        </div>
    </div>

    <div class="form-row">
        <div class="form-field">
            <input pInputText type="number" formControlName="iLongitud" class="form-control" 
                [placeholder]="'Ingrese longitud'" 
                min="0" appPermissionControl="P268K0004">
            <label>Longitud</label>
        </div>
    </div>

    <div class="button-section">
        <button mat-flat-button class="btn-success btn-menu" (click)="model ? update() : create()"
            [disabled]="!form.valid || loading" appPermissionControl="P268B0001">
            <mat-icon>save</mat-icon>
            {{ model ? 'Actualizar' : 'Guardar' }}
        </button>
    </div>
</form> 